import { EDITOR_TYPES, isPresetsReportEditorSchema } from 'reporting-data/tsTypes/editorTypes';
import { isConfigReport } from 'reporting-data/tsTypes/reportTypes';
import { getConfigType } from 'reporting-data/report/configReportGetters';
import { AGGREGATION, TIME_SERIES } from 'reporting-data/constants/configTypes';
import { validatePropertyExistsInDimensionSchema, PRESET_TYPES } from './presetsEditorUtils';
import { BasePresetsEditor } from './BasePresetsEditor';
import { strategy as singleObjectDimensionStrategy } from '../DimensionEditor/SingleObjectDimensionEditor';
import { ReportOptionsCategories } from '../../singleReportViewer/fullPage/sidebar/categorized/ReportOptionCategory';
import { jsx as _jsx } from "react/jsx-runtime";
const overTimePresetStrategy = {
  updateReport: (report, preset, propertyDefinitions, editorSchemaMap) => {
    if (getConfigType(report) !== TIME_SERIES) {
      const currentFirstDimension = singleObjectDimensionStrategy.getCurrentValue(report)[0];
      const newFirstDimension = preset.configuration[0].property;
      const breakdownEditorSchema = editorSchemaMap[EDITOR_TYPES.BREAKDOWN];
      let newSecondDimension = currentFirstDimension;
      if (breakdownEditorSchema && !validatePropertyExistsInDimensionSchema(currentFirstDimension, breakdownEditorSchema)) {
        newSecondDimension = undefined;
      }
      return singleObjectDimensionStrategy.updateReport(report, [propertyDefinitions[newFirstDimension], ...(newSecondDimension ? [propertyDefinitions[newSecondDimension]] : [])]);
    }
    return report;
  }
};
const totalsPresetStrategy = {
  updateReport: (report, preset, propertyDefinitions) => {
    if (getConfigType(report) !== AGGREGATION) {
      const newFirstDimension = preset.configuration[0].property;
      return singleObjectDimensionStrategy.updateReport(report, [propertyDefinitions[newFirstDimension]]);
    }
    return report;
  }
};
export const strategy = {
  isSupportedForReport: report => {
    return isConfigReport(report);
  },
  presetStrategies: {
    [PRESET_TYPES.OVER_TIME_PRESET]: overTimePresetStrategy,
    [PRESET_TYPES.TOTALS_PRESET]: totalsPresetStrategy
  }
};
// only supports dimension presets right now
const SingleObjectPresetsEditorComponent = props => {
  return /*#__PURE__*/_jsx(BasePresetsEditor, Object.assign({}, props, {
    strategy: strategy,
    schema: props.schema
  }));
};
export const SingleObjectPresetsEditor = {
  matchesEditorType: (report, schema) => {
    if (!isPresetsReportEditorSchema(schema)) {
      return false;
    }
    return strategy.isSupportedForReport(report);
  },
  EditorComponent: SingleObjectPresetsEditorComponent,
  category: ReportOptionsCategories.Group
};